import { useState } from 'react';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useComponentDidMount from 'Hooks/useComponentDidMount';

export const usePlannerTransition = (plannerTransitionRelationship, onSubmit) => {
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [plannerTransitionResource, setPlannerTransitionResource] = useState(null);
  const { displaySuccess } = useSnackbarContext();

  const loadPlannerTransition = async () => {
    // Safeguard to not passing in a relationship
    if (plannerTransitionRelationship !== undefined) {
      try {
        // Fetch the plannerTransitionCollection
        let plannerTransition;
        const plannerTransitionCollection = await plannerTransitionRelationship.link('related').get();
        // If no resources are returned create one, otherwise use it
        if (plannerTransitionCollection.resources().empty()) {
          [plannerTransition] = plannerTransitionCollection.create({ addToCollection: true });
          for (const [key] of Object.entries(plannerTransition.attributes())) {
            // set values to empty string instead of undefined, so they don't get filtered out in meta control.
            if (plannerTransition.attr(`${key}`) === undefined) {
              plannerTransition.attr(`${key}`, '');
            }
          }
        } else {
          plannerTransition = plannerTransitionCollection.resources().head();
        }
        setPlannerTransitionResource(plannerTransition);
      } catch (e) {
        setLoadingError(e);
      }
    } else {
      const e = {
        errors: [{ title: 'Failed to load Planner Transition', detail: 'Link not found' }],
      };
      setLoadingError(e);
    }
    setLoading(false);
  };

  const submitPlannerTransition = async () => {
    setSubmitting(true);
    try {
      await plannerTransitionResource.submit();
      displaySuccess('Submitted Planner Transition');
      return onSubmit();
    } catch (e) {
      setSubmitError(e.errors);
    } finally {
      setSubmitting(false);
    }
    return null;
  };

  useComponentDidMount(async () => {
    await loadPlannerTransition();
  });

  return {
    loading,
    loadingError,
    submitting,
    submitError,
    plannerTransitionResource,
    submitPlannerTransition,
    loadPlannerTransition,
  };
};
